import accessTokenKey from './accessTokenKey'
import accessTokenConfig from './accessTokenConfig'

const ACCESS_TOKEN_KEY = 'satellizer_access_token'
const ACCESS_TOKEN_CONFIG = 'access_token_config'

export default {
    ...accessTokenKey(ACCESS_TOKEN_KEY),
    ...accessTokenConfig(ACCESS_TOKEN_CONFIG),
}
